import { render, staticRenderFns } from "./ComandoLivre.vue?vue&type=template&id=a4a5fd1c"
import script from "./ComandoLivre.vue?vue&type=script&lang=js"
export * from "./ComandoLivre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports